import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InquiryService } from '../../../services/inquiry.service';
import { MaterialModule } from '../../../material.module';
import { ModalSnackbarService } from '../../../services/modal-snackbar.service';
import { FileUtilsService } from '../../../services/file-utils.service';
import { ActiveCurrencies, ActivePoolTypes } from '../../../models/inquiry.model';
import { AbstractInquiryCreateComponent } from '../../abstract-inquiry-create.component';

@Component({
  selector: 'app-invest-create',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule
  ],
  templateUrl: './invest-create.component.html',
  styleUrls: ['./invest-create.component.scss']
})
export class InvestCreateComponent extends AbstractInquiryCreateComponent {

  InvestPoolTypes = ActivePoolTypes;
  InvestCurrencies = ActiveCurrencies;

  constructor(
    fb: FormBuilder,
    service: InquiryService,
    snackBar: ModalSnackbarService,
    fileUtils: FileUtilsService
  ) {
    super(fb, service, snackBar, fileUtils);

    this.form = this.fb.group({
      pool: ['', [Validators.required]],
      amount: ['', [Validators.required]],
      currency: ['', [Validators.required]],
      ym: ['', [Validators.required]],
      body: ['', [Validators.maxLength(400)]],
      files: [[], [this.fileUtils.fileSizeValidator(20 * 1024 * 1024), this.fileUtils.minFileCountValidator(2)]] // 20MB
    });
  }

  submit() {
    if (this.form.invalid) return;

    const formData = new FormData();

    const title = this.form.value.pool + ' ・ ' + this.form.value.amount  + ' ' + this.form.value.currency + ' ・ ' + this.form.value.ym;
    const body = `ご希望の運用プラン : ${this.form.value.pool}
出資予定額 : ${this.form.value.amount}
運用通貨 : ${this.form.value.currency}
出資開始予定月 : ${this.form.value.ym}
連絡事項 : ${this.form.value.body}
`;

    formData.append('category', '新規出資依頼');
    formData.append('title', title);
    formData.append('child[body]', body);

    this.form.value.files.forEach((file: File, i: number) => {
      formData.append(`attachments[]`, file, file.name);
    });

    this.service.uploadWithFile(formData).subscribe({
      next: () => {
        this.snackBar.show('新規出資依頼を作成しました', '/invest');
      },
      error: () => {
        this.snackBar.show('作成に失敗しました');
      }
    });
  }
}
